<template>
  <div class="container flex-column">
      <div class="top">
            <van-row class="flex">
                <van-col span="12">
                    <div>订单数</div>
                    <div class="size1">10</div>
                </van-col>
                <van-col span="12">
                     <div>保费合计</div>
                    <div class="size1">18800.00</div>
                </van-col>
            </van-row>
            <van-divider class="divider"/>
      </div>
      <div class="bottom">
          <div v-for="(index) in 2" :key="index">
              <div class="size2">{{2021-index}}年</div>
              <div v-for="(index) in 12" :key="index">
                  <div class="cell flex">
                      <div class="mom">{{13-index}}月</div>
                      <div class="size3 flex">
                          <div class="width1">订单数：4</div>
                          <div>金额：6500</div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    created(){
        document.title="保费合计"
    }
}
</script>

<style scoped>
    .container{
        background: transparent;
       padding: 12px;
       color: #999;
    }
    .flex{
        display: flex;
        align-items: center;
    }
    .flex-column{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .top{
        width:100%;
        border-radius: 6px;
        background: linear-gradient(right,#f34740, #fb958a);
        color: #fff;
        font-size: 15px;
        position: relative;
    }
    .top>.van-row{
         height: 132px;
    }
    .size1{
        font-family: Source Han Sans CN Regular, Source Han Sans CN Regular-Regular;
        font-size: 25px;
        font-weight: bold;
        margin-top: 15px;
    }
    .divider{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-35px);
        border-color: #fff;
        border-width: 1px;
        height: 35px;
    }
    .bottom{
        width: 100%;    
    }
    .size2{
        font-size: 12px;
        margin-top: 24px;
    }
    .cell{
        width: 100%;
        height: 50px;
        background: #ffffff;
        box-shadow: 0px 5px 10px 2px rgba(64,63,63,0.07); 
        margin: 10px 0;
        border-radius: 5px;
    }
    .mom{
        width: 62px;
        margin-left: 16px;
        font-size: 17px;
        color:#333;
        text-align: start;
    }
    .size3{
        font-size: 14px;
        color: #666;
    }
    .width1{
        text-align: start;
        width:90px;
    }
</style>


// WEBPACK FOOTER //
// src/views/agentMy/totalPremium.vue